import { splitAirtimeMinutes } from "./airtime-format"

export enum SeriesKind {
  Reach = "reach",
  SharePercent = "sharePercent",
  AirtimeMinutes = "airtimeMinutes",
  SharePercentAirtime = "sharePercentAirtime",
}

function formatThousandsSpaced(n: number): string {
  return Math.round(n)
    .toString()
    .replace(/\B(?=(\d{3})+(?!\d))/g, " ")
}

/** Formats the month-total label from pre-computed API summary/sov values. */
export function formatSummaryTotal(
  kind: SeriesKind,
  summary: { totalAirtimeMinutes: number; totalReach: number },
  sov: { shareOfAirtime: number; shareOfReach: number }
): string {
  switch (kind) {
    case SeriesKind.Reach:
      return formatThousandsSpaced(summary.totalReach)
    case SeriesKind.AirtimeMinutes:
      return formatHeaderValue(
        SeriesKind.AirtimeMinutes,
        summary.totalAirtimeMinutes
      )
    case SeriesKind.SharePercent:
      return `${Math.round(sov.shareOfReach)}%`
    case SeriesKind.SharePercentAirtime:
      return `${Math.round(sov.shareOfAirtime)}%`
  }
}

export function formatHeaderValue(kind: SeriesKind, n: number): string {
  switch (kind) {
    case SeriesKind.Reach:
      return formatThousandsSpaced(n)
    case SeriesKind.SharePercent:
    case SeriesKind.SharePercentAirtime:
      return `${Math.round(n)}%`
    case SeriesKind.AirtimeMinutes: {
      const { h, m } = splitAirtimeMinutes(n)
      if (h === 0) return `${m}m`
      if (m === 0) return `${h}h`
      return `${h}h ${m}m`
    }
  }
}
